import axios from 'axios';
import Cookies from 'js-cookie';
import { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom';
import MainLayout from 'src/components/MainLayout';
import { AppConfig } from 'src/config/AppConfig';
import { ITransactions, IUser, IWorkerRatings } from 'src/helper/interfaces';
import Swal from 'sweetalert2';
import profileIcon from "../../../../assets/img/icons/vecteezy_man-empty-avatar-vector-photo-placeholder-for-social_36594092.jpg";
import { formatCategory, formatDiffrentDate } from 'src/utils/normalFuntions';
import permanentAddress from "../../../../assets/img/icons/address-permanent.svg";
import currentAddress from "../../../../assets/img/icons/address-current.svg";
import StarRating from 'src/components/layout/StarRating';
import LoadingGif from 'src/components/layout/Loader';
import { useAppDispatch, useAppSelector } from 'src/hooks/redux/hooks';
import Paginator from 'src/components/layout/Paginator';
import { getAllTransactions } from '../../transactions/Transaction';
import { getWorkerRatings } from '../../workers/Workers';
import { startLoading, stopLoading } from 'src/store/loading/loadingSlice';
import bill from "../../../../assets/img/icons/marketing-bill-payment-invoice-receipt-svgrepo-com.svg";
import eye from "../../../../assets/img/icons/eye-solid.svg"
interface sidePagesForUser {
   transactions: boolean,
   ratings: boolean
}

const getUserById = async (token: string, id: string) => {
   return await axios.get(`${AppConfig.DEV_SERVER}/user/${id}`, {
      headers: {
         "x-access-token": token
      }
   });
}

function UserDetailsPage() {
   const { id } = useParams();
   const Token = Cookies.get("token");
   const [transactions, setTransactions] = useState<ITransactions[]>([]);
   const [ratingsArray, setRatingsArray] = useState<IWorkerRatings[]>([]);
   const [selectedUser, setSelectedUser] = useState<IUser | null>(null);
   const [clickedSidePage, setClickedSidePage] = useState<sidePagesForUser>({
      transactions: true,
      ratings: false
   });
   const [PaginatedData, setPaginatedData] = useState({
      pageNo: 1,
      pageSize: 10,
      totalPages: 0
   });
   const dispatch = useAppDispatch();
   const loading = useAppSelector(state => state.loading.value);
   const setHandlePageClick = (page: keyof sidePagesForUser) => {
      setClickedSidePage({
         transactions: page === "transactions",
         ratings: page === "ratings"
      })
   }
   // console.log("userId: ", id)

   useEffect(() => {
      getUserById(Token as string, id as string).then((res) => {
         // console.log(res)
         if (res?.data?.status_code === 200) {

            setSelectedUser(res?.data?.data);

         } else {
            Swal.fire({
               icon: "error",
               title: "Oops...",
               text: `${res?.data?.data?.msg}`,

            });
         }
      })
   }, [Token, id])



   useEffect(() => {
      if (Token) {
         getAllTransactions(Token, "all", "user", id).then((res) => {
            // console.log(res?.data?.data?.data);
            if (res?.data?.status_code === 200) {
               // console.log(res?.data)
               setTransactions(res?.data?.data?.data);
               setPaginatedData({
                  ...PaginatedData,
                  totalPages: res?.data?.data?.totalPages
               })

            }
         })
            .catch((err: any) => {
               console.log(err)
            })
      }
   }, [Token, PaginatedData?.pageNo, PaginatedData?.pageSize, id]);

   useEffect(() => {

      if (Token) {
         const params = {
            token: Token,
            id: selectedUser?._id as string,
            pageNo: PaginatedData?.pageNo,
            pageSize: PaginatedData?.pageSize,
            type: "user",
         };
         getWorkerRatings(params).then((res) => {
            // console.log(res?.data?.data?.data);
            if (res?.data?.status_code === 200) {

               setRatingsArray(res?.data?.data?.results);
               setPaginatedData({
                  ...PaginatedData,
                  totalPages: res?.data?.data?.totalPages
               })

            }
         })
            .catch((err: any) => {
               console.log(err)
            })
      }
   }, [PaginatedData?.pageNo, PaginatedData?.pageSize, clickedSidePage?.ratings]);

   const convertedDate = formatDiffrentDate(selectedUser?.createdAt as string);

   const handleInvoiceClick = async (id: string, type: string) => {
      if (!id) return;
      dispatch(startLoading());
      try {
         const res = await axios.get(`${AppConfig.DEV_SERVER}/invoice/${id}`, {
            headers: {
               "x-access-token": Token,
            },
            params: {
               type: type,
            },
         });

         if (res?.data?.status_code === 200) {
            const pdfUrl = res?.data?.data?.file;
            // setPdf(pdfUrl);
            dispatch(stopLoading());
            // console.log(res)
            window.open(pdfUrl, "_blank"); // Open the PDF in a new tab
         } else {
            dispatch(stopLoading());
            Swal.fire({
               icon: "error",
               title: "Something Went Wrong...",
               text: `${res?.data?.msg}`,
            });
         }
      } catch (error) {
         dispatch(stopLoading());
         Swal.fire({
            icon: "error",
            title: "Error",
            text: "Failed to fetch the invoice.",
         });
      }
   };

   return (
      <MainLayout showAllFilters={true}>
         <div className=" main-div">

            <div className={`category-main me-2 p-3 p-md-4 `} style={{ background: "transparent" }}>

               <div className="row">
                  <div className="col-xxl-3 col-xl-4 p-2 theiaStickySidebar">
                     <div className="theiaStickySidebar"
                        style={{ paddingTop: " 0px", paddingBottom: "1px", position: "static", transform: 'none', top: "0px", left: "276px" }}>
                        <div className="card border-white ">
                           <div className="card-header border-1 " style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.175)" }}>
                              <div className="d-flex align-items-center flex-wrap row-gap-3">
                                 <div className="d-flex align-items-center justify-content-center avatar avatar-xxl border border-dashed me-2 flex-shrink-0 text-dark frames">
                                    <img
                                       src={
                                          selectedUser?.profile_pic
                                             ? typeof selectedUser?.profile_pic === 'string'
                                                ? selectedUser?.profile_pic
                                                : URL.createObjectURL(selectedUser?.profile_pic)
                                             : profileIcon
                                       }

                                    />
                                 </div>
                                 <div className="d-flex flex-column">
                                    <h5 className="mb-1 text-start">{selectedUser?.name ?? "NA"} </h5>
                                    <span className="text-start mb-1">{selectedUser?.phone ?? "NA"}</span>
                                    <span className="text-start">Joined: {convertedDate?.formattedDate ?? "NA"} </span>
                                 </div>
                              </div>
                           </div>
                           <div className="card-body text-start">
                              <h5 className="mb-3">Basic Information</h5>
                              <dl className="row mb-0">
                                 {/* Worker Type */}

                                 <dt className="col-4 fw-medium text-dark mb-3">User ID</dt>
                                 <dd className="col-8 mb-3">{selectedUser?._id ?? "NA"}</dd>
                                 <dt className="col-4 fw-medium text-dark mb-3">Dial Code</dt>
                                 <dd className="col-8 mb-3">{selectedUser?.dial_code ?? "NA"}</dd>

                                 <dt className="col-4 fw-medium text-dark mb-3">Otp</dt>
                                 <dd className="col-8 mb-3">{selectedUser?.otp ?? ""}</dd>
                                 {/* <dt className="col-4 fw-medium text-dark mb-3">Email</dt>
                                          <dd className="col-8 mb-3">{selectedUser?.otp}</dd> */}

                                 <dt className="col-4 fw-medium text-dark mb-3">Verified Otp</dt>
                                 <dd className="col-8 mb-3">{selectedUser?.is_otp_verified ? "Yes" : "No"}</dd>
                                 <dt className="col-4 fw-medium text-dark mb-3">User Verified</dt>
                                 <dd className="col-8 mb-3">{selectedUser?.is_user_verified ? "Yes" : "No"}</dd>
                                 <dt className="col-4 fw-medium text-dark mb-3">User Details</dt>
                                 <dd className="col-8 mb-3">{selectedUser?.is_user_details_completed ? "Completed" : "Incompleted"}</dd>

                              </dl>

                           </div>
                        </div>

                        <div className="card border-white">
                           <div className="card-header" style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.175)" }}>
                              <h5 className="mb-0 text-start">Address</h5>
                           </div>

                           <div className="card-body">
                              <div className="d-flex align-items-center mb-3">
                                 <span className="avatar avatar-md rounded me-2 flex-shrink-0 text-default" style={{ background: "#F8FAFC" }}>

                                    <img src={currentAddress} alt="currentAddress" />

                                 </span>
                                 <div className="text-start">
                                    <span className="text-dark font-weight-bold">
                                       Current Address
                                    </span>
                                    <p className="mb-0 text-start">
                                       {selectedUser?.address?.street || selectedUser?.address?.pin_code || selectedUser?.address?.city || selectedUser?.address?.country ?
                                          `${selectedUser?.address?.street ? (selectedUser?.address?.street + ",") : ""} ${selectedUser?.address?.pin_code || "NA"}, ${selectedUser?.address?.city || "NA"}, ${selectedUser?.address?.country || "NA"}`
                                          : "NA"
                                       }
                                    </p>


                                 </div>
                              </div>
                              <div className="d-flex align-items-center mb-3">
                                 <span className="avatar avatar-md rounded me-2 flex-shrink-0 text-default" style={{ background: "#F8FAFC" }}>

                                    <img src={permanentAddress} alt="permanentAddress" />

                                 </span>
                                 <div className="text-start">
                                    <span className="text-dark font-weight-bold">
                                       Permanent Address
                                    </span>
                                    <p className="mb-0 text-start">
                                       {selectedUser?.address?.street || selectedUser?.address?.pin_code || selectedUser?.address?.city || selectedUser?.address?.country ?
                                          `${selectedUser?.address?.street ? (selectedUser?.address?.street + ",") : ""} ${selectedUser?.address?.pin_code || "NA"}, ${selectedUser?.address?.city || "NA"}, ${selectedUser?.address?.country || "NA"}`
                                          : "NA"
                                       }
                                    </p>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div className="col-xxl-9 col-xl-8 p-2">

                     <div className="row ">

                        <div className="col-md-12">
                           <ul className="nav nav-tabs nav-tabs-bottom mb-4 border-bottom-0">

                              <li >
                                 <div className={` d-flex p-3 sidePages ${clickedSidePage?.transactions ? "active" : ""}`}
                                    onClick={() => {
                                       setHandlePageClick("transactions");
                                       setPaginatedData({
                                          ...PaginatedData,
                                          pageNo: 1
                                       });
                                    }}>
                                    <span className="d-flex justify-content-center align-items-center me-2">
                                       <svg version="1.1" id="_x32_" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 512 512" xmlSpace="preserve" fill={clickedSidePage?.transactions ? "#3D5EE1" : "#000000"} style={{ width: "13px", height: "13px" }}><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <style type="text/css">  .st0  </style> <g> <polygon className="st0" points="373.103,133.628 369.368,133.628 358.087,133.628 354.353,133.628 354.353,164.581 349.165,167.909 336.806,167.909 336.806,133.628 336.759,133.628 320.712,133.628 318.196,133.628 318.196,167.909 292.665,167.909 292.665,189.19 318.196,189.19 318.196,223.472 320.712,223.472 336.759,223.472 336.806,223.472 336.806,189.19 349.196,189.19 354.353,192.519 354.353,223.472 358.087,223.472 369.368,223.472 373.103,223.472 373.103,204.597 397.524,220.269 397.524,217.878 397.524,202.237 397.524,199.847 364.399,178.534 397.524,157.253 397.524,154.862 397.524,139.222 397.524,136.815 373.103,152.519 "></polygon> <path className="st0" d="M462.321,245.8c-2.359,0-7.422,0-14.344,0c0.609-24.641,4.391-58.063,10.688-92.297 c6.859-37.516,16.719-76.172,28.078-105.484l-0.078-0.031c0.922-2.203,1.594-4.688,1.578-7.266 c0.016-3.906-1.281-7.484-2.891-10.094c-3.109-4.922-6.75-7.406-10.469-9.672c-6.516-3.781-14.172-6.438-23.297-8.953 c-13.641-3.672-30.375-6.625-48.328-8.719c-17.938-2.078-37.047-3.281-55.156-3.281c-29.469,0.016-61.5,3.141-86.953,8.188 c-12.781,2.563-23.828,5.5-32.719,9.234c-4.484,1.938-8.453,3.969-12.219,7.078c-1.875,1.578-3.75,3.484-5.375,6.125 c-1.594,2.609-2.891,6.203-2.875,10.094c-0.016,2.625,0.656,5.141,1.594,7.359l-0.063,0.031 c11.188,28.328,21.063,66.953,27.953,104.719c2.766,15,5.031,29.891,6.781,44c-39.734,11.047-60.047,74.109-101.297,74.109v180.75 c39.484,0,144.234,43.906,175.938,50.266c35.906,7.188,82.828,23.031,107.719-10.781c15.359-20.844,39.406-101.781,57.453-159.188 C529.837,287.987,498.228,245.8,462.321,245.8z M430.196,148.284c-6.547,35.828-10.547,70.5-11.156,97.516 c-48.406,0-121.281,0-141.875,0c-0.641-27.188-4.672-62.203-11.25-98.188c-4.234-23.109-9.516-46.422-15.625-68.094l2.109,2.859 c32-12.359,37.703-33.109,37.781-49.563c18.531-2.422,39.047-3.906,57.922-3.875c19.25-0.016,40.156,1.5,58.953,4.016 c0.484,16.141,6.859,35.875,37.734,47.797l1.391-1.906C439.884,101.065,434.509,124.831,430.196,148.284z"></path> <path className="st0" d="M5.181,306.081v157.125c0,19.422,15.734,35.156,35.156,35.156h41.938c12.953,0,23.453-10.5,23.453-23.438 V270.94H40.337C20.915,270.94,5.181,286.675,5.181,306.081z"></path> </g> </g></svg>
                                    </span>
                                    <button className="border-0 bg-transparent" >
                                       Transactions
                                    </button>
                                 </div>
                              </li>

                              <li >
                                 <div className={` d-flex p-3 sidePages ${clickedSidePage?.ratings ? "active" : ""}`}
                                    onClick={() => {
                                       setHandlePageClick("ratings");
                                       setPaginatedData({
                                          ...PaginatedData,
                                          pageNo: 1
                                       });
                                    }}>
                                    <span className="d-flex justify-content-center align-items-center me-2" >
                                       <svg fill={clickedSidePage?.ratings ? "#3D5EE1" : "#000000"} height="200px" width="200px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 512 512" xmlSpace="preserve" style={{ width: "13px", height: "13px" }}><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <g> <path d="M501.108,324.808c-18.078-22.785-51.248-26.095-73.455-7.46l-79.115,66.383h-37.109 c18.518-7.578,31.898-25.423,32.467-46.178c0.797-29.075-22.487-52.931-51.476-52.931H137.134v-15.706 c0-9.222-7.477-16.699-16.699-16.699H16.699C7.477,252.218,0,259.695,0,268.917v213.755c0,9.222,7.477,16.699,16.699,16.699 h103.737c9.222,0,16.699-7.477,16.699-16.699v-27.328l32.695,27.43c9.006,7.557,20.442,11.718,32.199,11.718h156.499 c11.758,0,23.194-4.162,32.201-11.719L493.3,396.711C514.768,378.695,518.272,346.441,501.108,324.808z M103.737,465.972H33.398 V285.615h70.339C103.737,296.354,103.737,458.287,103.737,465.972z M471.83,371.125l-102.571,86.063 c-3.002,2.519-6.814,3.906-10.734,3.906H202.027c-3.919,0-7.73-1.387-10.733-3.906l-54.161-45.44v-93.727h155.286 c10.134,0,18.373,8.324,18.092,18.619c-0.266,9.692-8.706,17.577-18.815,17.577c-7.262,0-59.115,0-65.689,0 c-9.222,0-16.699,7.477-16.699,16.699s7.477,16.699,16.699,16.699h29.59l25.868,21.703c6.005,5.037,13.628,7.813,21.467,7.813 h45.607c7.838,0,15.462-2.774,21.468-7.814l79.115-66.383c7.76-6.511,19.424-5.432,25.824,2.634 C480.972,353.162,479.575,364.628,471.83,371.125z"></path> </g> </g> <g> <g> <path d="M368.08,92.437l-67.065-9.744l-29.992-60.772c-6.113-12.386-23.833-12.393-29.949,0l-29.992,60.772l-67.065,9.744 c-13.669,1.987-19.151,18.836-9.255,28.483l48.528,47.306l-11.457,66.794c-2.336,13.613,11.995,24.034,24.229,17.604 l59.986-31.536l59.984,31.535c12.157,6.392,26.58-3.898,24.229-17.604l-11.457-66.794l48.529-47.305 C387.225,111.279,381.757,94.424,368.08,92.437z M301.626,207.317c-54.351-28.574-36.583-28.69-91.155,0 c10.384-60.549,15.947-43.691-28.169-86.694c60.547-8.798,46.15,2.338,73.747-53.579c27.188,55.09,12.78,44.721,73.745,53.579 C285.814,163.494,291.21,146.586,301.626,207.317z"></path> </g> </g> </g></svg>

                                    </span>
                                    <button className="border-0 bg-transparent">
                                       Reviews On Worker
                                    </button>
                                 </div>
                              </li>



                           </ul>

                           {
                              clickedSidePage?.ratings ?
                                 <div className="card">
                                    <div className="card-header d-flex justify-content-between" style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.175)" }}>
                                       <h5 className="text-start mb-0" >
                                          Reviews Given To Workers
                                       </h5>

                                    </div>
                                    <div className="card-body">
                                       <div className="border rounded p-3 pb-0 transaction-body" >
                                          <div className="table-responsive">
                                             <table className="table  card-body">
                                                <thead>
                                                   <tr className="transaction-tr">
                                                      <th scope="col" className="text-start ps-4">Sr.No.</th>
                                                      <th scope="col" className="text-start ps-4">Ratings</th>
                                                      <th scope="col" className="text-start ps-4">Rating Type</th>
                                                      <th scope="col" className="text-start ps-4">Review</th>
                                                      <th scope="col" className="text-start ps-4">Worker Name</th>
                                                      <th scope="col" className="text-start ps-4">Worker Phone</th>
                                                      <th scope="col" className="text-start ps-4">Service Name</th>
                                                      {/* <th scope="col" className="text-start ps-4"></th> */}

                                                      <th scope="col" className="text-start ps-4">Published At</th>

                                                   </tr>

                                                </thead>
                                                <tbody>
                                                   {
                                                      ratingsArray && ratingsArray?.map((data, i) => {
                                                         // const createdAt = moment(data?.createdAt).tz('Asia/Kolkata').format('DD-MM-YYYY');
                                                         const createdAt = formatDiffrentDate(data?.createdAt);
                                                         const rowNumber = (PaginatedData?.pageNo - 1) * PaginatedData?.pageSize + (i + 1);
                                                         // console.log(data?.comment?.length)
                                                         const dotData = data?.comment
                                                            ?.slice(0, 40) + (data?.comment.length > 40 ? " ..." : "");

                                                         return (
                                                            <>
                                                               <tr key={data?._id}>
                                                                  <td className="text-start align-content-center ps-4">
                                                                     <span className="">
                                                                        {rowNumber}
                                                                     </span>

                                                                  </td>
                                                                  <td className="text-start align-content-center ps-4">
                                                                     <StarRating averageRating={data?.rating} />
                                                                  </td >
                                                                  <td className="text-start align-content-center ps-4">
                                                                     {data?.rating_type === "professionalServiceRatings" || data?.rating_type === "doorStepRatings" ? "Service" : "Worker"}
                                                                  </td >

                                                                  <td className="text-start align-content-center ps-4" title={data?.comment} style={{ cursor: "pointer" }} width={`${data?.comment?.length > 20 ? "200px" : "auto"}`}>
                                                                     {dotData}
                                                                  </td >

                                                                  <td className="text-start align-content-center ps-4" >

                                                                     {data?.worker_name}
                                                                  </td>
                                                                  <td className="text-start align-content-center ps-4">
                                                                     {data?.worker_phone}

                                                                  </td>

                                                                  <td className="text-start align-content-center ps-4 ">

                                                                     {data?.rating_type === "normal" ? "None" : data?.service_title}
                                                                  </td>

                                                                  <td className="icon-td align-content-center text-start ps-4" >
                                                                     {createdAt?.formattedDate}
                                                                  </td>
                                                               </tr >

                                                            </>


                                                         )
                                                      }
                                                      )
                                                   }

                                                </tbody>
                                             </table>
                                             {
                                                loading ? <LoadingGif /> : ""
                                             }
                                          </div>
                                          <Paginator
                                             totalPages={PaginatedData?.totalPages}
                                             pageNo={PaginatedData?.pageNo}
                                             onPageChange={(e, no) => setPaginatedData({
                                                ...PaginatedData,
                                                pageNo: no

                                             })}
                                             alignment="right"
                                          />
                                       </div>

                                    </div>

                                 </div> :
                                 clickedSidePage?.transactions ?
                                    <div className="card">
                                       <div className="card-header" style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.175)" }}>
                                          <h5 className="text-start mb-0" >
                                             Transactions
                                          </h5>
                                       </div>
                                       <div className="card-body">
                                          <div className="border rounded p-3 pb-0 transaction-body" >
                                             <div className="table-responsive">
                                                <table className="table  card-body">
                                                   <thead>
                                                      <tr className="transaction-tr">
                                                         <th scope="col" className="text-start ps-4">sr.No</th>
                                                         <th scope="col" className="text-start ps-4">Order Name</th>
                                                         <th scope="col" className="text-start ps-4">Order Type</th>
                                                         <th scope="col" className="text-start ps-4">Date</th>
                                                         <th scope="col" className="text-start ps-4">Transaction ID</th>
                                                         <th scope="col" className="text-start ps-4">Amount</th>
                                                         <th scope="col" className="text-start ps-4">Status</th>
                                                         <th scope="col" className="col-lg-2 ps-4 ">Action</th>
                                                      </tr>
                                                   </thead>
                                                   <tbody>
                                                      {
                                                         transactions && transactions?.map((data: ITransactions, i) => {
                                                            // const createdAt = moment(data?.createdAt).tz('Asia/Kolkata').format('DD-MM-YYYY');
                                                            const createdAt = formatDiffrentDate(data?.createdAt);
                                                            const rowNumber = (PaginatedData?.pageNo - 1) * PaginatedData?.pageSize + (i + 1);
                                                            let orderType = data?.order_type;

                                                            if (data?.order_type === "requirement") {
                                                               orderType = "job_post"
                                                            }
                                                            else {
                                                               orderType = "doorstep_service"
                                                            }

                                                            // console.log("orderType: ", orderType);
                                                            const requirementPath = `/requeriments/${data?.order_id}`;
                                                            const doorstepPath = `/doorstep-orders/${data?.order_id}`;
                                                            return (
                                                               <tr key={data?._id}>


                                                                  <td className="text-start align-content-center ps-4">
                                                                     <span className="">
                                                                        {rowNumber}
                                                                     </span>

                                                                  </td>
                                                                  <td className="text-start align-content-center ps-4">
                                                                     <span className="">
                                                                        {data?.order_name}
                                                                     </span>

                                                                  </td>
                                                                  <td className="text-start align-content-center ps-4">
                                                                     <span className="">
                                                                        {formatCategory(data?.order_type)}
                                                                     </span>

                                                                  </td>
                                                                  <td className="text-start align-content-center ps-4">
                                                                     <span className="">
                                                                        {createdAt?.formattedDate}
                                                                     </span>

                                                                  </td>
                                                                  <td className="text-start align-content-center ps-4">
                                                                     <span className="">
                                                                        {data?.unique_id}
                                                                     </span>

                                                                  </td>

                                                                  <td className="text-start align-content-center ps-4 ">
                                                                     <span className=" align-items-center">
                                                                        &#8377; {data?.payment_amount}
                                                                     </span> </td>

                                                                  <td className="icon-td align-content-center text-start ps-4">
                                                                     Success
                                                                  </td>

                                                                  <td className="align-content-center ">
                                                                     <div className="d-flex justify-content-center gap-3 align-items-center">
                                                                        <Link to={`${orderType === "job_post" ? requirementPath : doorstepPath}`}>

                                                                           <button className="btn btn-sm delete_btn " >
                                                                              <img src={eye} />
                                                                           </button>
                                                                        </Link>
                                                                        <button
                                                                           className="btn btn-sm delete_btn"
                                                                           onClick={() => handleInvoiceClick(data?.order_id, orderType)}
                                                                           style={{ marginBottom: "1px" }}
                                                                        >
                                                                           <img src={bill} alt="invoice" />
                                                                        </button>

                                                                     </div>

                                                                  </td>
                                                               </tr>
                                                            )
                                                         }
                                                         )
                                                      }

                                                   </tbody>
                                                </table>
                                                {
                                                   loading ?
                                                      <div>
                                                         <LoadingGif />
                                                      </div>

                                                      : ""
                                                }
                                             </div>
                                             <Paginator
                                                totalPages={PaginatedData?.totalPages}
                                                pageNo={PaginatedData?.pageNo}
                                                onPageChange={(e, no) => setPaginatedData({
                                                   ...PaginatedData,
                                                   pageNo: no
                                                })}
                                                alignment="right"
                                             />
                                          </div>

                                       </div>

                                    </div> : ""
                           }

                        </div>



                     </div>
                  </div>

               </div>
            </div>
         </div>
      </MainLayout>
   )
}

export default UserDetailsPage;